import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import GalleryNav from './GalleryNav.js';

/**
 * Slider component
 */
export default class Gallery extends Base {
  breakpoints = ['xxs', 'xs', 's'];

  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    refs: ['slider', 'pagination', 'slide[]'],
    components: {
      GalleryNav,
    },
  };

  /**
   * Get slide elements
   * @returns {HTMLElement[]}
   */
  get slides() {
    return this.$refs.slide;
  }

  /**
   *
   */
  mounted() {
    if (this.isMobile) {
      this.slider = new Swiper(this.$refs.slider, {
        modules: [Pagination],
        slidesPerView: 1,
        grabCursor: true,
        pagination: {
          el: this.$refs.pagination,
          clickable: true,
        },
      });
    }
  }

  /**
   * Check if current breakpoint is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
